'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBrowser;
function isBrowser() {
  return typeof window !== 'undefined' && window.document;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toolbox/lib/utils/is-browser.js
// module id = 526
// module chunks = 0